import { StyleSheet } from 'aphrodite';
import { white } from '../../styles/colors';
import { Layouts } from '../../styles/styles';

const cardGridItemSpacing = 20;

export const styleSheet = StyleSheet.create({
	body: {
		...Layouts.verticalStack(20),
		boxSizing: 'border-box',
		paddingBottom: 30,
	},
	cardGrid: {
		boxSizing: 'border-box',
	},
	cardGridContent: {
		display: 'grid',
		gridTemplateColumns: `repeat(auto-fill, minmax(min(300px, 100%), 1fr))`,
		marginTop: cardGridItemSpacing,
		gap: 16,
	},
	container: {
		background: '#F9F9F9',
		boxSizing: 'border-box',
		overflowY: 'auto',
		padding: `0 16px`,
		flex: 1,
	},
	filterRow: {
		...Layouts.horizontalStack(16),
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginTop: 20,
	},
	levTemplatesHeaderIndustrySelector: {
		background: white,
		width: 200,
	},
	loadingContainer: {
		minHeight: 200,
		padding: 40,
	},
	levTemplatesHeaderIndustrySelectorOption: {
		height: 40,
		background: white,
		fontSize: 14,
	},
});
